//CRN_20260508 - Riskline TripReady (Lite + Pro) service (PULL via SureSim backend proxy)
//CRN_20260513 - https://riskline.readme.io/reference/apis-overview

import { catchError, map, Observable, of, throwError } from 'rxjs';
import { eSimApiPaths } from '../../consts';
import { environment } from 'src/environments/environment';
import { ExceptionsService } from '../utelize/general/exceptions-service';
import { HttpClientService } from '../utelize/general/http-client-service';
import { Injectable } from '@angular/core';
import { StringResultDTO } from 'src/app/core/interfaces/general/string-result';
import { TripReadyRequestDTO, TripReadyResponseDTO } from '../../models/system/riskline/riskline-trip-ready.dto';

@Injectable({ providedIn: 'root' })
export class RisklineTripReadyService {

  constructor(
    private exceptionsService: ExceptionsService,
    private httpClientService: HttpClientService
  ) { }

  public getJson(request: TripReadyRequestDTO): Observable<TripReadyResponseDTO> {
    try {
      return this.httpClientService
             ._post<TripReadyResponseDTO>(environment.eSimApi +
                                          eSimApiPaths.RiskIntelligence + '/' +
                                          eSimApiPaths.RiskIntelligenceTripReady,
                                          request)
             .pipe(
               catchError((error) => {
                 return throwError(() => new Error('RisklineTripReadyService.getJson() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of();
    }
  }

  public getLandingPageUrl(countryIsoCode: string): Observable<string> {
    try {
      if (!countryIsoCode || countryIsoCode.trim()=='')
        throw new Error('RisklineTripReadyService.getLandingPageUrl() - countryIsoCode is required');

      return this.httpClientService
             .get<StringResultDTO>(environment.eSimApi +
                                   eSimApiPaths.RiskIntelligence + '/' +
                                   eSimApiPaths.RiskIntelligenceTripReadyLanding +
                                   '?countryIsoCode=' + countryIsoCode)
             .pipe(
               map((response: StringResultDTO) => response?.result ?? ''),
               catchError((error) => {
                 return throwError(() => new Error('RisklineTripReadyService.getLandingPageUrl() - ' + this.exceptionsService.formatHttpError(error)));
               })
             );
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return of('');
    }
  }
}
